import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h2, paragraphSmall } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --borderWidth: ${fluid(4, 5)};
  --titleHighlight: linear-gradient(180deg, #72ccf4 0%, #368cb0 100%);

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    row-gap: ${fluid(40, 54)};

    @media ${until(Device.TabletLarge)} {
      padding-top: calc(var(--sectionSpacingTop) * 1.5);
      padding-bottom: calc(var(--sectionSpacingBottom) * 1.5);
    }
  }
`;
const ItemGrid = styled.div `
  grid-column: span 12;
  display: grid;
  gap: ${fluid(16, 24)};
  grid-template-columns: repeat(2, 1fr);

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(12, 1fr);
  }
`;
const StatItem = styled.div `
  --borderColourStart: ${brand.primary.white};
  --borderColourEnd: ${brand.primary.white};

  position: relative;
  border-radius: 4px;
  overflow: clip;
  z-index: 1;
  grid-column: span 2;

  &[data-stat='true'] {
    padding: ${fluid(20, 24)};
    display: grid;
    place-content: center;
    gap: ${fluid(12, 16)};
    text-align: center;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    z-index: -1;
  }

  &::before {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, var(--borderColourStart) 0%, var(--borderColourEnd) 100%);
  }

  &::after {
    background-color: #2b2b2b;
    top: var(--borderWidth);
    left: var(--borderWidth);
    width: calc(100% - var(--borderWidth) * 2);
    height: calc(100% - var(--borderWidth) * 2);
  }

  @media ${until(Device.Tablet)} {
    &[data-first-img='true'] {
      grid-column: span 1;
      grid-row: var(--imgRow, 1) / span 1;
    }
  }

  @media ${from(Device.Tablet)} {
    grid-row: var(--row, 1) / span 1;
    grid-column: span 4;

    &[data-type='tall'] {
      grid-column: var(--col, 5) / span 3;
      grid-row: var(--row, 2) / span 2;
    }

    &[data-type='standard'] {
      grid-column: var(--col, 1) / span 4;
    }

    &[data-type='wide'] {
      grid-column: var(--col, 1) / span 5;
    }
  }
`;
const ImageWrapper = styled(m.div) `
  ${imageWrapperPreserveRatio(504, 262)};

  height: calc(100% - var(--borderWidth) * 2);
  width: calc(100% - var(--borderWidth) * 2);
  margin: var(--borderWidth);

  @media ${until(Device.Tablet)} {
    ${StatItem}[data-first-img='true'] & {
      aspect-ratio: 1;
    }
  }

  @media ${from(Device.Tablet)} {
    ${StatItem}[data-stat='false'] & {
      aspect-ratio: unset;
    }
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const StatText = styled(m.span) `
  ${h2};

  margin-bottom: 0;
`;
const Context = styled.span `
  ${fonts.poppins.extraBold};

  display: block;
  font-size: ${fluid(15, 20)};
  line-height: ${fluid(22, 32)};
  margin: ${fluid(4, 16)} 0 0;
`;
const Description = styled.div `
  ${contentStyles};

  p,
  li {
    ${paragraphSmall};
  }

  ul:not([style*='list-style-type']) li::before {
    top: ${fluid(5, 7.5)};
  }
`;
const StatsListStyles = {
    Container,
    Context,
    Image,
    ImageWrapper,
    ItemGrid,
    StatItem,
    StatText,
    Description,
};
export default StatsListStyles;
